import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { AI_AUTOMATIONS_LOCAL_API_REQUESTS } from './constants';

/**
 * PATCH /nerobotti/automations/{id} — switch one on or off, or reschedule it.
 *
 * Only `enabled` and `schedule` are accepted. Who an automation runs as is
 * fixed when it is created and cannot be changed here, by design: an edit
 * that could repoint it at somebody else would hand the editor that person's
 * reach.
 */
export const updateAutomation = async ({ automationId, enabled, schedule }) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `nerobotti/automations/${encodeURIComponent(automationId)}`,
    body: {
      ...(enabled === undefined ? {} : { enabled }),
      ...(schedule === undefined ? {} : { schedule }),
    },
    isLocalApiRequest: AI_AUTOMATIONS_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
